// Firebase configuration for DentCloud Ads Management
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY || "AIzaSyDYNSX4Dbe00JaFJ0F1zUbjSHUj651vLc8",
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN || "dentcloud-ads.firebaseapp.com",
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID || "dentcloud-ads",
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET || "dentcloud-ads.firebasestorage.app",
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || "175922708275",
  appId: process.env.VUE_APP_FIREBASE_APP_ID || "1:175922708275:web:a6dc8c9f58234586540846",
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID || "G-FCYCFH8ZZJ"
};

// Initialize Firebase (using global Firebase from CDN)
let app, db;

const initializeFirebase = () => {
  try {
    if (typeof window !== 'undefined' && window.Firebase) {
      app = window.Firebase.initializeApp(firebaseConfig);
      db = window.Firebase.getFirestore(app);
      console.log('Firebase initialized successfully');
      return { app, db };
    } else {
      console.error('Firebase CDN not loaded. Make sure Firebase scripts are included in index.html');
      return { app: null, db: null };
    }
  } catch (error) {
    console.error('Firebase initialization error:', error);
    return { app: null, db: null };
  }
};

// Auto-initialize when module loads
const { app: firebaseApp, db: firestore } = initializeFirebase();

export { firebaseApp as app, firestore as db, firebaseConfig, initializeFirebase };